module.exports = __webpack_public_path__ + "static/003overlay-e8a964f8375da4114f50d002766c2108.png";